import { compose } from 'recompose';

import SalesByBarber from './SalesByBarber';
import { withDefaultColumns } from './columns';
import SalesByBarberContainer from './SalesByBarberContainer';
import withDefaultSalesByBarberDataProvider from './withDefaultSalesByBarberDataProvider';
import PaymentDepositColumns from './PaymentDepositColumns';

export { default as SalesByBarber } from './SalesByBarber';
export { getColumns as salesByBarberDefaultColumns } from './columns';
export { default as SalesByBarberContainer } from './SalesByBarberContainer';
export { default as withDefaultSalesByBarberDataProvider } from './withDefaultSalesByBarberDataProvider';

const DefaultSalesByBarber = compose(
  withDefaultColumns,
  PaymentDepositColumns,
  withDefaultSalesByBarberDataProvider,
  SalesByBarberContainer,
)(SalesByBarber);

export default DefaultSalesByBarber;
